'use client';

import { useAppSelector } from 'lib/hooks';
import { RootState } from 'lib/store';
import { selectUserDynamicValues } from 'slices/dynamicDataSelectors';
import { UserDynamicValues } from 'types/user';
import { contentWithData } from 'utils/content';

interface FooterDisclaimerContentProps {
  disclaimer: string;
}

const FooterDisclaimerContent = ({
  disclaimer,
}: FooterDisclaimerContentProps) => {
  const userData = useAppSelector((state: RootState) =>
    selectUserDynamicValues(state)
  ) as UserDynamicValues;

  if (typeof disclaimer !== 'string' || disclaimer.trim() === '') {
    return null;
  }

  return <>{contentWithData(disclaimer, userData)}</>;
};

export default FooterDisclaimerContent;
